var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoorcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.97368,
    cy: 2.7105,
    r: 1,
    stroke: "#081930",
    strokeWidth: 1.94737
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.50005,
    cy: 2.7105,
    r: 1,
    stroke: "#081930",
    strokeWidth: 1.94737
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0264,
    cy: 2.7105,
    r: 1,
    stroke: "#081930",
    strokeWidth: 1.94737
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.97368,
    cy: 8.23687,
    r: 1,
    stroke: "#081930",
    strokeWidth: 1.94737
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.50005,
    cy: 8.23687,
    r: 1,
    stroke: "#081930",
    strokeWidth: 1.94737
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0264,
    cy: 8.23687,
    r: 1,
    stroke: "#081930",
    strokeWidth: 1.94737
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.97368,
    cy: 13.7632,
    r: 1,
    stroke: "#081930",
    strokeWidth: 1.94737
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.50005,
    cy: 13.7632,
    r: 1,
    stroke: "#081930",
    strokeWidth: 1.94737
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.50005,
    cy: 19.2896,
    r: 1,
    stroke: "#081930",
    strokeWidth: 1.94737
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0264,
    cy: 13.7632,
    r: 1,
    stroke: "#081930",
    strokeWidth: 1.94737
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorcode);
export default __webpack_public_path__ + "static/media/Doorcode.80d10f48d8d6df46aa5101becb4253d4.svg";
export { ForwardRef as ReactComponent };